import { Getter } from 'jotai';
import { Atom } from 'jotai/vanilla';
import { sectionAtom } from '@/atoms/section';
import { SectionAtomMap } from '@/types/section';

export const getAtomForSection =
  <T>(sectionMapAtom: Atom<SectionAtomMap<T>>) =>
  async (get: Getter) => {
    const section = get(sectionAtom);
    if (section === null) return [];

    const sectionMap = get(sectionMapAtom);
    const atomForSection = sectionMap[section];
    if (!atomForSection) {
      // eslint-disable-next-line no-console
      console.error(
        `Unhandled mapping from ${section} section to ${sectionMapAtom.debugLabel}.\n${section} is not a handled property.`,
      );
      return [];
    }

    return get(atomForSection);
  };
